import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SupportRequest } from './support-api';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  constructor(
    private http: HttpClient,
    private store: Store
  ) {}

  sendSupportEmail(payload: SupportRequest): Observable<{ sent: boolean }> {
    return this.http.post<{ sent: boolean }>(`${environment.apiUrl}/support/issues`, payload);
  }
}
